<template>
  <div class="role-page page-padding-top">
    <top-bar :title="$t('content.title2')"  @back="back" ></top-bar>

    <div class="notice-detail">
      <h2>Terms of Service</h2>
      <p class="last-updated">Last Updated: {{currentDate}}</p>
      
      <div class="section">
        <h3>1. Introduction</h3>
        <p>Welcome to {{appName}}, a digital asset trading platform. These Terms of Service govern your access to and use of our website, mobile application, and services. By accessing or using our services, you agree to be bound by these Terms.</p>
      </div>
      
      <div class="section">
        <h3>2. Registration and Account Security</h3>
        <ul>
          <li>You must register for an account and provide accurate information.</li>
          <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
          <li>You must immediately notify us of any unauthorized use of your account.</li>
          <li>We reserve the right to suspend, disable, or terminate your account if we believe that you have violated these Terms.</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>3. KYC and AML Compliance</h3>
        <ul>
          <li>We are committed to complying with Know Your Customer (KYC) and Anti-Money Laundering (AML) regulations.</li>
          <li>You may be required to complete identity verification procedures.</li>
          <li>You agree to provide accurate information for all verification procedures.</li>
          <li>We reserve the right to refuse service if KYC/AML procedures are not completed.</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>4. Trading Rules</h3>
        <ul>
          <li>You are responsible for understanding the risks involved in digital asset trading.</li>
          <li>All trades are final and cannot be reversed once confirmed.</li>
          <li>We reserve the right to suspend trading in case of market anomalies or technical issues.</li>
          <li>Trading fees apply to all transactions as specified on our Fee Schedule.</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>5. Deposits and Withdrawals</h3>
        <ul>
          <li>You are responsible for ensuring that deposit addresses are correct.</li>
          <li>Deposits may require a certain number of network confirmations.</li>
          <li>Withdrawal requests are subject to processing times and security checks.</li>
          <li>We reserve the right to delay or reject requests if we suspect fraudulent activity.</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>6. Prohibited Activities</h3>
        <p>You agree not to engage in any of the following prohibited activities:</p>
        <ul>
          <li>Violating any laws or regulations</li>
          <li>Market manipulation or fraudulent activities</li>
          <li>Unauthorized access to our systems</li>
          <li>Using our services to launder money</li>
          <li>Using automated systems to extract data without permission</li>
          <li>Any activity that disrupts or interferes with our services</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>7. Limitation of Liability</h3>
        <p>Our services are provided on an "as is" basis without any warranties. We are not responsible for losses resulting from:</p>
        <ul>
          <li>Your failure to maintain account security</li>
          <li>Fluctuations in digital asset prices</li>
          <li>System downtime or technical issues</li>
          <li>Actions of third parties</li>
          <li>Regulatory actions affecting digital assets</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>8. Changes to Terms</h3>
        <ul>
          <li>We reserve the right to modify these Terms at any time.</li>
          <li>We will notify you of material changes through our website or by email.</li>
          <li>Your continued use of our services constitutes acceptance of the updated Terms.</li>
        </ul>
      </div>
      
      <div class="section">
        <h3>9. Contact Information</h3>
        <p>If you have any questions about these Terms, please contact us</p>
      </div>
    </div>
  </div>
</template>
<script>
import { getNoticeList } from '@/api/index'
import topBar from '@/components/topBar'
export default {
  components: {
    topBar
  },
  computed: {
    appName() {
      return this.$store.state.appName
    }
  },
  data() {
    return {
      title: '',
      currentDate: new Date().toISOString().split('T')[0]
    }
  },
  mounted() {
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    readAll() {

    }
  }
}
</script>
<style scoped>
.notice-detail {
  padding: 15px;
  color: #333;
  line-height: 1.5;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #0d47a1;
}

.last-updated {
  color: #666;
  font-style: italic;
  margin-bottom: 15px;
  font-size: 12px;
}

.section {
  margin-bottom: 20px;
}

h3 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  margin-top: 16px;
  color: #0d47a1;
}

p {
  margin-bottom: 8px;
  font-size: 14px;
}

ul {
  padding-left: 16px;
  margin-bottom: 8px;
}

li {
  margin-bottom: 4px;
  font-size: 14px;
}

.contact-email {
  font-size: 16px;
  font-weight: 600;
  color: #0d47a1;
  margin: 12px 0;
}
</style>